import { render, staticRenderFns } from "./liveClassDetails.vue?vue&type=template&id=52fc31ea&scoped=true"
import script from "./liveClassDetails.vue?vue&type=script&lang=js"
export * from "./liveClassDetails.vue?vue&type=script&lang=js"
import style0 from "./liveClassDetails.vue?vue&type=style&index=0&id=52fc31ea&prod&lang=less"
import style1 from "./liveClassDetails.vue?vue&type=style&index=1&id=52fc31ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fc31ea",
  null
  
)

export default component.exports